import React, { useEffect, useState } from "react";
import _ from "lodash";
import ImageGallery from "react-image-gallery";
import { constants } from "../../../utils";

export default function Carousel(props) {
  const [images, setImages] = useState(props.images);
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  function formatImages() {
    const formattedImages = [];
    _.forEach(props.images, function (image) {
      const newImage = {
        original: frontImageUrl + image.attributes.url,
        thumbnail: frontImageUrl + image.attributes.formats.small.url,
        linkTo: image.attributes.alternativeText,
      };
      formattedImages.push(newImage);
    });
    setImages(formattedImages);
  }

  function imageClick(image) {
    const clickedImage = _.find(images, function (x) {
      return x.original === image.src;
    });
    window.location.href = clickedImage.linkTo;
  }

  useEffect(() => {
    formatImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.images]);

  return (
    <ImageGallery
      items={images}
      onClick={(e) => imageClick(e.target)}
      showPlayButton={false}
      showBullets={true}
      showThumbnails={false}
      showFullscreenButton={false}
    />
  );
}
